import { createHttpClient } from '@adapters/HttpClient';
import { CourierInvoicesApiAdapter } from '../../adapters';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { COURIER_INVOICES_PAGE_SIZE } from '../../constants';
import type { CourierInvoicesListResponse } from '../../models/types';

export const useCourierInvoicesInfiniteList = () => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new CourierInvoicesApiAdapter(httpClient), [httpClient]);

  return useInfiniteQuery<CourierInvoicesListResponse, Error>({
    queryKey: ['courier-invoices-infinite'],
    queryFn: ({ pageParam }) => adapter.list(pageParam as number, COURIER_INVOICES_PAGE_SIZE),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = lastPage.meta;
      return current_page < last_page ? current_page + 1 : undefined;
    },
    staleTime: 60 * 1000,
  });
};
